module.exports = __webpack_public_path__ + "92abd0818f3f1308543d5102fb4cb8e5.png";